import { useMutation } from '@tanstack/react-query';
import { apiPost } from '../lib/api';

export interface ContactMessage {
  name: string;
  email: string;
  subject: string;
  message: string;
  website: string;
}

export function useSendContactMessage() {
  return useMutation({
    mutationFn: (input: ContactMessage) => apiPost<{ ok: true }>('/api/contact', input),
  });
}
